import { fontSize, fontWeight, lineHeight } from "../../constants/typography";
import { BOX_SHADOWS } from "../../constants/shadows";
import { NeutralColors } from "../../constants/colors";
import styled, { css } from 'styled-components';
import { backgroundColors, SELECT_POSITIONS } from "./constants";
var Distribute = styled.div.withConfig({
  componentId: "sc-saqyu6-0"
})(["display:flex;"]);
export var Text = styled.span.withConfig({
  componentId: "sc-saqyu6-1"
})(["color:inherit;font-size:", ";line-height:", ";font-weight:", ";"], fontSize.xSmall, lineHeight.large, fontWeight.regular);
export var Prefix = styled.div.withConfig({
  componentId: "sc-saqyu6-2"
})(["margin-right:8px;line-height:0;"]);
export var Suffix = styled.div.withConfig({
  componentId: "sc-saqyu6-3"
})(["line-height:0;margin-left:4px;"]);

// Useful for styles overrides
export var Container = styled.div.withConfig({
  componentId: "sc-saqyu6-4"
})(["line-height:0;position:relative;"]);
export var focusedBgColor = '#f0f0f0';
export var OptionLinkContainer = styled(Distribute).withConfig({
  componentId: "sc-saqyu6-5"
})(["appearance:none;margin:0;border:none;max-width:100%;text-align:left;color:inherit;cursor:pointer;min-height:32px;background-color:", ";&:hover,&:focus[data-focus-visible]{background-color:", ";}text-decoration:none;outline:none;width:100%;&[aria-disabled='true']{pointer-events:none;cursor:default;}&:hover{text-decoration:none;}"], function (_ref) {
  var isFirstLanguageSelected = _ref.isFirstLanguageSelected;
  return isFirstLanguageSelected ? focusedBgColor : backgroundColors.positive;
}, focusedBgColor);
export var OptionLink = styled(Text).withConfig({
  componentId: "sc-saqyu6-6"
})(["color:", ";line-height:2.4;font-weight:200;font-size:", ";padding:6px 23px;"], NeutralColors.Ink, fontSize.small);
export var Button = styled.button.withConfig({
  componentId: "sc-saqyu6-7"
})(["background:none;border:none;padding:0;font:inherit;cursor:pointer;outline:none;display:flex;align-items:center;color:inherit;&:hover{opacity:0.8;}"]);
export var MenuWrapper = styled.div.withConfig({
  componentId: "sc-saqyu6-8"
})(["background-color:", ";border-radius:8px;box-shadow:", ";padding:8px 0;position:absolute;z-index:1;pointer-events:none;transform:scale(0.85);transform-origin:bottom left;will-change:transform,opacity;visibility:hidden;opacity:0;transition:transform 150ms ease-in,opacity 150ms ease-in,visibility 150ms ease-in;", ";", ""], NeutralColors.White, BOX_SHADOWS.medium, function (_ref2) {
  var position = _ref2.position;
  return position === SELECT_POSITIONS.TOP ? 'bottom: 2rem' : 'top: 2rem';
}, function (_ref3) {
  var isOpen = _ref3.isOpen;
  return isOpen && css(["pointer-events:initial;opacity:1;visibility:visible;transform:scale(1);"]);
});